module.exports = __webpack_public_path__ + "static/media/img_2.c99480f5.png";